export default "__VITE_ASSET__QUdmMLhP__$_?url__"